import { render, staticRenderFns } from "./DocPrintAtendimento.vue?vue&type=template&id=4cdf242d&"
import script from "./DocPrintAtendimento.vue?vue&type=script&lang=js&"
export * from "./DocPrintAtendimento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports